<template>
    <div class="ur-section__indicator" v-if="isShowSectionIndicator">
        <ur-section-row>
            <ur-section-column possession="1" v-for="i in 12" :key="i"/>
        </ur-section-row>
    </div>
</template>

<script>
const keyCode = {
    NUMBER_1: 49,
    NUMBER_2: 50,
    NUMBER_3: 51,
    NUMBER_4: 52,
};
export default {
    name: 'ur-section-indicator',
    props: {
        isShow: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isShowSectionIndicator: false
        }
    },
    mounted() {
        if (process.env.NODE_ENV === 'dev') {
            document.addEventListener('keyup', this.onKeyUp);
            this.isShowSectionIndicator = this.isShow;
        }
    },
    beforeDestroy() {
        if (process.env.NODE_ENV === 'dev') {
            document.removeEventListener('keyup', this.onKeyUp);
        }
    },
    methods: {
        onKeyUp (e) {
            if (e.altKey && e.keyCode === keyCode['NUMBER_1']) {
                this.isShowSectionIndicator = !this.isShowSectionIndicator;
            } else if (e.altKey && e.keyCode === keyCode['NUMBER_2']) {
                this.$emit('toggle-guide', 'row');
            } else if (e.altKey && e.keyCode === keyCode['NUMBER_3']) {
                this.$emit('toggle-guide', 'col');
            } else if (e.altKey && e.keyCode === keyCode['NUMBER_4']) {
                this.$emit('toggle-guide', 'box');
            }
        }
    }
}
</script>